// ═══════════════════════════════════════════════════════════════════════
// Fichiers des salariés (correctif sécurité) — plus aucun fichier personnel n'est servi par
// une URL publique. Les photos et pièces se chargent par l'API authentifiée
// (GET /api/fichiers?chemin=…), qui vérifie le droit de l'utilisateur sur le salarié concerné,
// puis s'affichent depuis une URL locale temporaire (blob) libérée après usage.
// ═══════════════════════════════════════════════════════════════════════
import { useEffect, useState } from 'react';
import axios from 'axios';

const API = process.env.REACT_APP_API_URL ? `${process.env.REACT_APP_API_URL}/api` : '/api';

/** URL d'API pour un chemin stocké (« /uploads/… ») ; les autres valeurs sont laissées telles quelles. */
const urlApi = (chemin) => (typeof chemin === 'string' && chemin.startsWith('/uploads/')
  ? `${API}/fichiers?chemin=${encodeURIComponent(chemin)}`
  : chemin);

const recupererBlob = async (chemin) => {
  const res = await axios.get(urlApi(chemin), { responseType: 'blob' });
  return res.data;
};

/** Hook : URL affichable d'une image protégée (null tant qu'elle n'est pas chargée ou si refusée). */
export function useFichierSecurise(chemin) {
  const [url, setUrl] = useState(null);
  useEffect(() => {
    if (!chemin) { setUrl(null); return undefined; }
    let objet = null;
    let actif = true;
    recupererBlob(chemin)
      .then((blob) => { if (actif) { objet = URL.createObjectURL(blob); setUrl(objet); } })
      .catch(() => { if (actif) setUrl(null); });
    return () => { actif = false; if (objet) URL.revokeObjectURL(objet); };
  }, [chemin]);
  return url;
}

/**
 * Ouvre un document protégé dans un nouvel onglet. La fenêtre est ouverte immédiatement (pour
 * ne pas être bloquée par le navigateur), puis reçoit le fichier une fois l'accès vérifié.
 * Renvoie un message d'erreur lisible en cas de refus, sinon null.
 */
export async function ouvrirFichierSecurise(cheminOuUrl) {
  const fenetre = window.open('', '_blank');
  try {
    const blob = await recupererBlob(cheminOuUrl);
    const objet = URL.createObjectURL(blob);
    if (fenetre) fenetre.location.href = objet; else window.location.assign(objet);
    setTimeout(() => URL.revokeObjectURL(objet), 60000);
    return null;
  } catch (e) {
    if (fenetre) fenetre.close();
    const statut = e.response?.status;
    if (statut === 403) return 'Vous n\'êtes pas autorisé à consulter ce document.';
    if (statut === 404) return 'Document introuvable.';
    return 'Le document n\'a pas pu être ouvert.';
  }
}
